// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"750":"pacientes","966":"dashboard"}[chunkId] + "." + {"750":"b7df3e10","966":"9131ff38"}[chunkId] + ".js";
};